import { ApiClient, ShipApi } from "../../Types"

export const ShipSettingsViewData = {
  loadCompanion(api: ApiClient) {
    return new ShipApi(api).ships.companion({ params: {} }).call();
  },
};
